// src/store/index.js

import { configureStore } from '@reduxjs/toolkit';
import complianceReducer from './slices/complianceSlice';
import fscComplianceReducer from './slices/fscComplianceSlice';
import cloudDashboardReducer from './slices/cloudDashboardSlice';
import licenseSlice from './slices/licenseSlice';
import userSlice from './slices/userSlice';
import businessSlice from './slices/businessSlice';
import crowdstrikeSlice from './slices/crowdstrikeSlice';

export const store = configureStore({
  reducer: {
    compliance: complianceReducer,
    fscCompliance: fscComplianceReducer,
    cloudDashboard: cloudDashboardReducer,
    license: licenseSlice,
    user: userSlice,
    businessMembers: businessSlice,
    crowdStrike: crowdstrikeSlice,
  },
});
